<template>
    <div class="customerBox">
        <avue-crud :data="data" :option="option" :page.sync='page'
                   @current-change='changePage' @size-change="sizeChange">
            <template slot="index" slot-scope="scope">
                {{page.total - ((page.currentPage - 1) * page.pageSize + scope.row.$index)}}
            </template>
        </avue-crud>
    </div>
</template>

<script>
import { getCustomerList_qy } from '@/api/operator';

export default {
    name:'customerList_qy',
    data(){
        return {
            listArgument: {
                limit: 10,
                page: 1
            },
            page: {
                currentPage: 1,
                total: 20,  //总数
                pageSize: 10  //每页条数
            },
            data: [],
            option: {
                stripe: true,
                addBtn: false,  //新增按钮
                align: 'center',  //文本居中
                menuAlign: 'center', //操作栏居中
                columnBtn: false,  //列动态显隐按钮
                refreshBtn: false,  //刷新按钮
                editBtn: false,  //编辑按钮
                delBtn: false,  //删除按钮
                menuType: 'menu',
                menu:false,
                menuBtnTitle: '操作',
                column: [
                    {
                        label: '序号',
                        prop: 'index'
                    },
                    // {
                    //     label: '企业ID',
                    //     prop: 'id'
                    // },
                    {
                        label: '企业名称',
                        prop: 'company_name',
                        width: 300
                    }, {
                        label: '联系人姓名',
                        prop: 'jbr_name'
                    }, {
                        label: '联系人手机号',
                        prop: 'user_mobile'
                    },
                    // {
                    //     label: '总合同份数',
                    //     prop: 'total_contract_num'
                    // },  {
                    //     label: '剩余合同数',
                    //     prop: 'contract_num'
                    // },  {
                    //     label: '已用合同数',
                    //     prop: 'used_contract_num'
                    // },
                    {
                        label: '仲裁立案数',
                        prop: 'zhcai_num'
                    },  {
                        label: '调解立案数',
                        prop: 'tiaojie_num'
                    },
                    {
                        label: '总额',
                        prop: 'total_money'
                    },
                    {
                        label: '已用',
                        prop: 'yiyong_money'
                    },
                    {
                        label: '余额',
                        prop: 'keyong_money'
                    },
                    {
                        label: '合同单价',
                        prop: 'ht_money'
                    },
                    {
                        label: '注册时间',
                        prop: 'create_time',
                        width: 200
                    },
                ]
            }
        }
    },
    methods:{
        // 分页
        changePage(num){
            this.listArgument.page = num;
            getCustomerList_qy(this.listArgument).then(res=>{
                this.data = res.data.list;
                this.page.total = res.data.count;
            })
        },
        // 切换每一页条数
        sizeChange(val){
            this.listArgument.limit = val;
            this.listArgument.page = 1;
            this.getList();
        },
        getList(){
            getCustomerList_qy(this.listArgument).then(res=>{
                if (res.code==200){
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage=1
                }else{
                    this.$message.error(res.msg)
                }
            })
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style scoped>
    .customerBox{
        margin: 10px;
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }
    ::v-deep .avue-crud__menu{
        min-height: 0px;
    }
</style>